module.exports = __webpack_public_path__ + "img/bancaigy.61502ad3.jpg";